import axios from "axios";
export const MANUAL_ORDERS_URL =`${process.env.REACT_APP_API_URL}/manual-orders`;// "api/orders";
export const PRODUCTS_URL =`${process.env.REACT_APP_API_URL}/product`;

export function getAllProducts(params) {
  return axios.get(PRODUCTS_URL, {params});
}
export function getManualOrders(params) {
  return axios.get(MANUAL_ORDERS_URL, {params});
}
export function getManualOrderById(order_id) {
  return axios.get(`${MANUAL_ORDERS_URL}/${order_id}`);
}
export function createManualOrder(order) {
  return axios.post(MANUAL_ORDERS_URL, { order });
}
export function deleteManualOrder(order_id) {
  return axios.delete(`${MANUAL_ORDERS_URL}/${order_id}`);
}
export function updateManualOrder(order) {
  return axios.put(`${MANUAL_ORDERS_URL}/${order.id}`, { order });
}
export function updateStatusManualOrder(order_id, order) {
  return axios.put(`${MANUAL_ORDERS_URL}/${order_id}/status`, order );
}


